export const environment = {
    production: false,
    apiUrl: 'https://haylie.bosswebapps.net/api/',
    //apiUrl: 'http://localhost:5197/api/',
    apiUrlVesper: 'https://localhost:7178/api/',
    //apiUrlVesper: 'https://vesper.bosswebapps.net/api/',
    //apiUrlVesper: 'https://sandbox.bosswebapps.net/api/',
    featureFlag: true
};
